import validate from "/Users/rice/xtable-pos-v3/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/Users/rice/xtable-pos-v3/middleware/auth.global.ts";
import expired_45global from "/Users/rice/xtable-pos-v3/middleware/expired.global.ts";
import seat_45run_45mode from "/Users/rice/xtable-pos-v3/modules/seat/middleware/seatRunMode.ts";
import manifest_45route_45rule from "/Users/rice/xtable-pos-v3/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  expired_45global,
  seat_45run_45mode,
  manifest_45route_45rule
]
export const namedMiddleware = {}